import React, {useMemo} from "react";
import {Col, Container, Form, FormControl, FormGroup, Row} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import {dateToString, dateWithZeroTime} from "../../tools";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {collection, query, where} from "firebase/firestore";
import {appFirestore} from "../../../index";
import {employeesFBConverter} from "../employees/EmployeesFBConverter";
import LogisticsCalendar from "./LogisticsCalendar";
import LeftRightSelector from "../../components/LeftRightSelector";

export default function LogisticsView() {
    const [firstDate, setFirstDate] = React.useState<Date>(dateWithZeroTime(new Date())!);

    const employeesQuery = useMemo(() => query(
        collection(appFirestore, "employees"),
        where("isLogistics", "==", true),
        where("isEmployee", "==", true),
        where("startDate", "<=", firstDate),
    ).withConverter(employeesFBConverter), [firstDate]);
    const [employees, loadingEmployees, errorEmployees] = useCollectionData(employeesQuery);

    const [visibleDays, setVisibleDays] = React.useState<number>(7);
    function addDay() {
        setFirstDate(dateWithZeroTime(new Date(firstDate.getTime() + 24 * 60 * 60 * 1000))!);
    }
    function subDay() {
        setFirstDate(dateWithZeroTime(new Date(firstDate.getTime() - 24 * 60 * 60 * 1000))!);
    }
    function addWeek() {
        setFirstDate(dateWithZeroTime(new Date(firstDate.getTime() + 7 * 24 * 60 * 60 * 1000))!);
    }
    function subWeek() {
        setFirstDate(dateWithZeroTime(new Date(firstDate.getTime() - 7 * 24 * 60 * 60 * 1000))!);
    }
    function addMonth() {
        setFirstDate(dateWithZeroTime(new Date(firstDate.getFullYear(), firstDate.getMonth() + 1, firstDate.getDate()))!);
    }
    function subMonth() {
        setFirstDate(dateWithZeroTime(new Date(firstDate.getFullYear(), firstDate.getMonth() - 1, firstDate.getDate()))!);
    }
    function addVisibleDays() {
        setVisibleDays(visibleDays + 1);
    }
    function subVisibleDays() {
        if (visibleDays > 1) {
            setVisibleDays(visibleDays - 1);
        }
    }

    return (
        <Container fluid>
            <h1>Календар ТРАНСПОРТ</h1>

            <Row className={"mb-3"}>
                <Col xs={"auto"}>
                    <Row>
                        <Col className={"pe-3 text-end"} xs={"auto"}>
                            <Form.Label>
                                Начална дата: </Form.Label>
                        </Col>
                        <Col>
                            <div className={"w-100px"}>
                                <ReactDatePicker
                                    selected={firstDate}
                                    value={dateToString(firstDate)}
                                    onChange={date => {
                                        setFirstDate(dateWithZeroTime(date ?? new Date())!);
                                    }}
                                    className={"form-control"}
                                />
                            </div>
                        </Col>
                        <Col xs={"auto"}>
                            <Row className={"flex-nowrap "}>
                                <Col className={"pe-3 text-end"} xs={"auto"}>
                                    <Form.Label className={"w-75px text-right"}>Брой дни: </Form.Label>
                                </Col>
                                <Col>
                                    <LeftRightSelector onLeft={() => subVisibleDays()} onRight={() => addVisibleDays()}>
                                        <FormGroup>
                                            <FormControl value={visibleDays.toString()} className={"text-center"}
                                                         type={"number"} readOnly/>
                                        </FormGroup>
                                    </LeftRightSelector>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <LeftRightSelector onLeft={() => subDay()} onRight={() => addDay()}>
                                Ден
                            </LeftRightSelector>
                        </Col>
                        <Col>
                            <LeftRightSelector onLeft={() => subWeek()} onRight={() => addWeek()}>
                                Седмица
                            </LeftRightSelector>
                        </Col>
                        <Col xs={"auto"}>
                            <LeftRightSelector onLeft={() => subMonth()} onRight={() => addMonth()}>
                                Месец
                            </LeftRightSelector>
                        </Col>
                    </Row>
                </Col>
                <Col/>
            </Row>

            <LogisticsCalendar firstDate={firstDate} daysCount={visibleDays} drivers={employees ?? []} />
        </Container>
    );
}
